import { api } from "@/api/client";

// Personal Data Hub — human-friendly secure hub (Phase 1).
export const hubApi = {
  access: () => api.get("/hub/access").then((r) => r.data),
  summary: () => api.get("/hub/summary").then((r) => r.data),
  joinWaitlist: () => api.post("/hub/waitlist").then((r) => r.data),

  // admin switch (founder)
  getSwitch: () => api.get("/hub/admin/switch").then((r) => r.data),
  setSwitch: (live) => api.post("/hub/admin/switch", { live }).then((r) => r.data),

  // security
  security: () => api.get("/hub/security").then((r) => r.data),
  enrollVoice: (blob) => {
    const fd = new FormData();
    fd.append("audio", blob, "voice.webm");
    return api.post("/hub/security/voice", fd).then((r) => r.data);
  },
  verifyVoice: (blob) => {
    const fd = new FormData();
    fd.append("audio", blob, "voice.webm");
    return api.post("/hub/security/voice/verify", fd).then((r) => r.data);
  },
  disableVoice: () => api.post("/hub/security/voice/disable").then((r) => r.data),

  // email rules + gmail
  emailRules: () => api.get("/hub/email/rules").then((r) => r.data),
  addEmailRule: (p) => api.post("/hub/email/rules", p).then((r) => r.data),
  editEmailRule: (id, p) => api.put(`/hub/email/rules/${id}`, p).then((r) => r.data),
  delEmailRule: (id) => api.delete(`/hub/email/rules/${id}`).then((r) => r.data),
  gmailConnect: () => api.get("/hub/email/gmail/connect", { params: { origin: window.location.origin } }).then((r) => r.data),
  scanEmail: () => api.post("/hub/email/scan").then((r) => r.data),
  renameInbox: (id, label) => api.put(`/hub/email/accounts/${id}`, { label }).then((r) => r.data),
  disconnectInbox: (id) => api.delete(`/hub/email/accounts/${id}`).then((r) => r.data),

  // bank
  bank: () => api.get("/hub/bank").then((r) => r.data),
  addManualBank: (p) => api.post("/hub/bank/manual", p).then((r) => r.data),
  editManualBank: (id, p) => api.put(`/hub/bank/manual/${id}`, p).then((r) => r.data),
  delManualBank: (id) => api.delete(`/hub/bank/manual/${id}`).then((r) => r.data),

  // crypto
  crypto: () => api.get("/hub/crypto").then((r) => r.data),
  addCrypto: (p) => api.post("/hub/crypto", p).then((r) => r.data),
  editCrypto: (id, p) => api.put(`/hub/crypto/${id}`, p).then((r) => r.data),
  revealCrypto: (id) => api.get(`/hub/crypto/${id}/reveal`).then((r) => r.data),
  refreshCrypto: (id) => api.post(`/hub/crypto/${id}/refresh`).then((r) => r.data),
  delCrypto: (id) => api.delete(`/hub/crypto/${id}`).then((r) => r.data),

  // shares
  shares: () => api.get("/hub/shares").then((r) => r.data),
  addShare: (p) => api.post("/hub/shares", p).then((r) => r.data),
  editShare: (id, p) => api.put(`/hub/shares/${id}`, p).then((r) => r.data),
  delShare: (id) => api.delete(`/hub/shares/${id}`).then((r) => r.data),
  securitySetup: (p) => api.post("/hub/security-setup", p).then((r) => r.data),
};
